 
import cf from 'canvas-fingerprint';


const getFingerprintHeader = ()=>{

    let fingerPrintHeader = {
        'html-canvas-fingerprint' :  cf.md5,
        'navigator-agent-string' : navigator.userAgent ,
        'navigator-appCodeName' : navigator.appCodeName ,
        'navigator-appName' : navigator.appName ,
        'navigator-appVersion' : navigator.appVersion ,
        'navigator-language' : navigator.language ,
        'navigator-platform' : navigator.platform ,
        'navigator-product' : navigator.product ,
        'navigator-vendor' : navigator.vendor ,
        'navigator-vendor' : navigator.vendor ,
        'navigator.userAgentData' : navigator.userAgentData
    };

    return fingerPrintHeader;
};

const authSignFetchReqestWithGivenAccessToken = (  url , requestObj , accessToken ) => {

    if( !requestObj.headers ){
        requestObj.headers = {};
    }

    if( accessToken ){
        requestObj.headers.Authorization = 'Bearer ' + accessToken;
    }

    // requestObj.headers.DeviceFingerprint = JSON.stringify(getFingerprintHeader());

    return [
        url ,
        requestObj
    ]
};


const authSignFetchReqest = (  url , requestObj , authService ) => {

    if( !requestObj.headers ){
        requestObj.headers = {};
    }

    if( authService.hasIdentity()  ){
        const identity =  authService.getCurrentIdentity();
        const token = ( identity.identity ? identity.identity.token : (identity.authIdentity ?  identity.authIdentity.token : '--'));
       
        requestObj.headers.Authorization = 'Bearer ' + token;

    }

    requestObj.headers.DeviceFingerprint = JSON.stringify(getFingerprintHeader());

    return [
        url ,
        requestObj 
    ]
}
const authSignXhrReqest = (  url , xhr , authService ) => {
    if( authService.hasIdentity()  ){
        const identity =  authService.getCurrentIdentity();
        const token = ( identity.identity ? identity.identity.token : (identity.authIdentity ?  identity.authIdentity.token : '--'));
       
        xhr.setRequestHeader('Authorization', 'Bearer ' + token)
        xhr.setRequestHeader('DeviceFingerprint', 'Bearer ' +  JSON.stringify(getFingerprintHeader()));

    }
    return [
        url ,
        xhr 
    ]
}

export default authSignFetchReqest;
export { authSignXhrReqest , authSignFetchReqestWithGivenAccessToken }; 
 